import { styled } from '@clickcease/cc-client-components-lib'

export const BundleDataStyled = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
})
